import Icon from "app/components/Icon";
import Img from "app/components/Image";
import { UserType } from "app/components/Types/UserType";

export function UserAvatar({ user }: { user: UserType; }) {
    return (
        <div className="rounded-full h-32px w-32px border-2 border-gray-1C1C1C bg-gray-343434 -mx-4px flex items-center justify-center overflow-hidden" title={user.name}>
            {user.thumbnail ? <Img className="h-full w-full object-cover" src={user.thumbnail} /> : <Icon className="text-white" name='user' />}
        </div>
    );
}
